import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId, openCalendly } from "./utils";

const links = [
  { label: "How It Works", id: "how-it-works" },
  { label: "What We Fix", id: "leak-map" },
  { label: "Revenue Roadmap", id: "roadmap" },
  { label: "Packages", id: "packages" },
  { label: "FAQ", id: "faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="main-nav-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-brand-gray-soft/70 shadow-[0_4px_30px_rgba(17,17,17,0.05)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => go("top")}
            data-testid="logo-home-link"
            className="flex items-center shrink-0"
            aria-label="Apex Flow AI home"
          >
            <img src="/apex-flow-logo.png" alt="Apex Flow AI" className="h-11 md:h-12 w-auto object-contain" />
          </button>

          <nav className="hidden lg:flex items-center gap-9">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-${l.id}`}
                onClick={() => go(l.id)}
                className="group relative font-sans text-sm font-medium text-brand-black/75 hover:text-brand-black transition-colors duration-300"
              >
                {l.label}
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-brand-gold transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-6">
            <a
              href="#final-cta"
              onClick={(e) => {
                e.preventDefault();
                go("final-cta");
              }}
              data-testid="client-login-link"
              className="font-sans text-sm font-medium text-brand-black/75 hover:text-brand-gold transition-colors duration-300"
            >
              Client Login
            </a>
            <button
              data-testid="book-call-nav"
              onClick={openCalendly}
              className="inline-flex items-center rounded-full bg-brand-black text-white px-5 py-2.5 font-sans text-sm font-semibold tracking-wide transition-all duration-300 shadow-[0_8px_24px_rgba(17,17,17,0.18)] hover:shadow-[0_10px_30px_rgba(200,154,61,0.32)] hover:-translate-y-0.5"
            >
              Book a Free Call
            </button>
          </div>

          <button
            className="lg:hidden text-brand-black p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-brand-gray-soft px-6 py-6 space-y-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full text-left py-3 font-sans text-base font-medium text-brand-black/80 hover:text-brand-gold transition-colors border-b border-brand-gray-soft/60"
            >
              {l.label}
            </button>
          ))}
          <a
            href="#final-cta"
            onClick={(e) => {
              e.preventDefault();
              go("final-cta");
            }}
            data-testid="mobile-client-login"
            className="block w-full text-left py-3 font-sans text-base font-medium text-brand-black/80 hover:text-brand-gold"
          >
            Client Login
          </a>
          <button
            data-testid="mobile-book-call"
            onClick={() => {
              setOpen(false);
              openCalendly();
            }}
            className="mt-3 w-full rounded-full bg-brand-black text-white px-5 py-3.5 font-sans text-sm font-semibold tracking-wide"
          >
            Book a Free Call
          </button>
        </div>
      )}
    </header>
  );
}
